import React, { useCallback } from 'react';
import styles from './Toggle.module.scss';
import cx from 'classnames';

const Toggle = ({ id, size = 'medium', className, checked, onChange, disabled, onClick }) => {
  const handleChange = useCallback(
    e => {
      !disabled && onChange(e);
    },
    [disabled, onChange]
  );

  return (
    <div className={cx(styles.container, className)}>
      <input
        type="checkbox"
        name="checkbox"
        id={`checkbox-${id}`}
        className={styles.checkboxInput}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        onClick={onClick}
      />
      <label htmlFor={`checkbox-${id}`} className={cx(styles.checkboxLabel, styles[size])} onClick={onClick} />
    </div>
  );
};

export default Toggle;
